import React, { ChangeEvent, Component, useState } from "react";
import "./QuoteQBOEmailEstimateModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import IVendorModel from "../../../models/IVendorModel";

type Props = {
    vendor: IVendorModel;
    closeModalFn: () => void;
    commitFn: (emailAddress?: string) => void;
};

export const QuoteQBOEmailEstimateModal: React.FC<Props> = (props) => {
    const getEmail = () => {
        if (props.vendor.Vendor_Integration?.qbo_Email) {
            return props.vendor.Vendor_Integration.qbo_Email;
        } else {
            if (props.vendor.email) {
                return props.vendor.email;
            } else {
                return "";
            }
        }
    };

    const [emailAddress, setEmailAddress] = useState<string>(getEmail());

    const closeModal = () => {
        props.closeModalFn();
    };

    const continueFn = () => {
        props.commitFn(emailAddress);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        setEmailAddress(value);
    };

    return (
        <div className={"QuoteQBOEmailEstimateModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"email_address"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"email_address"} showIsReqAsterik={true} />
                    <div>
                        <OwInputWrapper name={"email_address"} fn={handleChange} value={emailAddress} />
                    </div>
                </div>

                <div className={"mt-2"}>
                    <OwButton title={"continue"} fn={continueFn} disabled={!emailAddress} />
                </div>
            </div>
        </div>
    );
};
